export type EndpointMethod = 'post' | 'delete' | 'put' | 'patch' | 'get'
export type EndpointQuery = Record<string, any>
export type EndpointHeaders = Record<string, string>

export type EndpointSpecInterfaceUrlObject = {
  endpoint: string
  params?: (string | number)[]
  version?: string
}

export type EndpointSpecInterfaceUrl = string | EndpointSpecInterfaceUrlObject

export const isEndpointSpecInterfaceUrlObject = (
  value: any,
): value is EndpointSpecInterfaceUrlObject => value && value.endpoint

export interface EndpointSpecInterface<TRequestBody = Record<string, any>> {
  url: EndpointSpecInterfaceUrl
  method: EndpointMethod
  data?: TRequestBody
  query?: EndpointQuery
  arrayInFormatWithDuplicatedKeys?: boolean
}

type EndpointResponse<TResponse = any> = Promise<TResponse> | TResponse

export type ApiProviderInterface<
  TRequestBody = Record<string, any>,
  TResponse = any,
> = (
  endpoint: EndpointSpecInterface<TRequestBody>,
) => EndpointResponse<TResponse>

export type EndpointInterface<
  TResponse = any,
  TRequestBody = Record<string, any>,
> = (
  provider: ApiProviderInterface<TRequestBody, TResponse>,
) => EndpointResponse<TResponse>
